import type { NilHundredResponseNil100FilterResponseRelatedPagedData } from '@on3/api';
import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';
import { Link } from '@public/components/Link';
import { Nil100WidgetItems } from '@public/components/Nil/Nil100WidgetItems';
import { Nil100 } from '@public/components/Svg/Nil100';
import clsx from 'clsx';

import styles from './Nil100Widget.module.scss';

interface INil100Widget
  extends NilHundredResponseNil100FilterResponseRelatedPagedData {
  gender?: 'mens' | 'womens';
  isModule?: boolean;
}
export const Nil100Widget = ({
  list,
  gender,
  isModule = false,
}: INil100Widget) => {
  const { currentSite } = useSite();
  const primaryColor = currentSite?.organization?.primaryColor ?? '#fe3b1f';

  const viewAllLink =
    gender === 'womens'
      ? '/nil/rankings/player/womens-nil-valuations/'
      : '/nil/rankings/player/nil-valuations/';

  const athletes = list?.filter((i) => !!i.person) ?? [];

  return (
    <section
      className={clsx(styles.block, {
        [styles.module]: isModule,
      })}
    >
      <div
        className={styles.logo}
        style={{ borderBottom: `2px solid ${primaryColor}` }}
      >
        <Nil100 className={styles.nilLogo} fill={primaryColor} />
      </div>

      <ol className={styles.list}>
        {athletes.map((item, index) => (
          <Nil100WidgetItems
            {...item}
            indexRank={index + 1}
            isModule={isModule}
            key={item.person?.key}
          />
        ))}
      </ol>

      <footer className={styles.links}>
        <Link href={viewAllLink} useSiteColor>
          Complete List
        </Link>
        <Link
          href="/nil/news/about-on3-nil-valuation-per-post-value/"
          useSiteColor
        >
          About
        </Link>
      </footer>
    </section>
  );
};
